import chatIcon from "@/assets/icons/chatbot.svg";

const state = () => ({
  messagesFromSelectedConversation: [],
  supportAgent: {
    id: "assistant",
    name: "Assistant",
    avatarUrl: chatIcon,
  },
  currentUser: {
    id: "user",
    name: "User"
  },
  isChatOverviewVisible: false
});

const getters = {};
const actions = {};
const mutations = {
  setMessagesFromSelectedConversation(state, messages) {
    if (!messages || messages.length === 0)
      state.messagesFromSelectedConversation.length = 0;

    state.messagesFromSelectedConversation = messages.map((message) => ({
      id: message.messageId,
      author: message.role === "assistant" ? state.supportAgent : state.currentUser,
      conversationId: message.currentConversationId,
      timestamp: message.timestamp,
      text: message.content,
      attachments: message.attachments && message.attachments.length > 0 ? message.attachments : []
    }));
  },
	displayChatOverviewPopup(state) {
		state.isChatOverviewVisible = true;
	},
	closeChatOverviewPopup(state) {
		state.isChatOverviewVisible = false;
	}
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
